// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0d70e2e4-168":"1a192a9d027805577e4e","0d70e2e4-794":"3d48add888cb130eb70c","0d70e2e4-735":"f9599a3f2add268b6065","0d70e2e4-91":"4add1f68960d9b77c9bf"}[chunkId] + ".js";
};